import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MdbModalRef, MdbSelectModule } from 'src/lib/mdb5-adapted/public-api';

import { RiskScoreModel } from '@lmsModels';
import { LmsModalFrameComponent } from '@lmsSharedUI';

@Component({
  selector: 'app-add-risk-score',
  templateUrl: './add-risk-score.component.html',
  styleUrls: ['./add-risk-score.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, LmsModalFrameComponent, MdbSelectModule],
})
export class AddRiskScoreComponent implements OnInit {
  riskScoreModel: RiskScoreModel = new RiskScoreModel();
  addRiskScoreForm: FormGroup;
  submitted: boolean = false;

  constructor(public dialogRef: MdbModalRef<AddRiskScoreComponent>, private formBuilder: FormBuilder) {}

  public lstParameterTypes: any[] = [
    { value: 'COUNTRY', parameterType: 'Country' },
    { value: 'PRODUCT', parameterType: 'Product' },
    { value: 'CUSTOMER_TYPE', parameterType: 'Customer Type' },
    { value: 'RANGE', parameterType: 'Range' },
    { value: 'WEIGHTING', parameterType: 'Weighting' },
  ];

  ngOnInit(): void {
    this.addRiskScoreForm = this.formBuilder.group({
      parameterType: [this.riskScoreModel.parameterType, [Validators.required]],
      description: [this.riskScoreModel.description, [Validators.required]],
      score: [this.riskScoreModel.score, [Validators.required]],
    });
  }

  saveRiskScore() {
    this.submitted = true;
    let isValidData = true;

    if (this.addRiskScoreForm.invalid) {
      isValidData = false;
      console.log('Form is invalid...');
    }
    return this.dialogRef.close(this.addRiskScoreForm.value);
  }

  close() {
    this.dialogRef.close();
  }

  get validateRiskScoreValues() {
    return this.addRiskScoreForm.controls;
  }
}
